// La enum Topics viene riusata poi anche nelle traduzioni nel componente frontend del first-sync-loading, oltre che nei gateway del backend

export enum Topics {
  INTERFACES = "Interfaces",
  DASHBOARD = "Dashboard",
  SYSMESSAGES = 'Sysmessages',
  ATTACHMENT = 'Attachment',
  ISSUES = 'Issues',
  HISTORY = 'History',
  //PERMISSION = 'Permission',
  ISSUE_TYPES = 'IssueTypes',
  PROJECTS = 'Projects',
  PROJECT_CATEGORIES = 'ProjectCategories',
  COMPANIES = 'Companies',
  PROJECT_SCOPES = 'ProjectScopes',
  ISSUE_COMMENTS = 'IssueComments',
  ENTITY_INTERACTIONS = 'EntityInteractions',
  USERS = "Users",
  WORKFLOWS = "Workflows",
  TAGS = "Tags",
  MILESTONES = "Milestones",
  APPOINTMENT = "Appointment",
  ISSUE_STATES = "IssueStates",
  ISSUE_STATE_WORKFLOWS = "IssueStateWorkflows",
  ISSUE_TYPE_INTERFACES = "IssueTypeInterfaces",
  ISSUE_TYPE_WORKFLOWS = "IssueTypeWorkflows",
  IID_OL_CLIENTE = "IID_OL_Cliente",
  IID_OL_CONTRATTO = "IID_OL_Contratto",
  IID_OL_RIFERIMENTI = "IID_OL_Riferimenti",
  IID_OL_RIFERIMENTI_UI = "IID_OL_RiferimentiUi",
  IID_OL_CONDOMINIO = "IID_OL_Condominio",
  IID_OL_OLO_REQUEST = "IID_OL_OloRequest",
  IID_OL_ACTIVATION_REQUEST = "IID_OL_ActivationRequest",
  IID_EP_ASSETS = "IID_EP_Assets",
  IID_EP_RICHIESTA_PERMESSO = "IID_EP_Richiesta_Permesso",
  IID_EP_RISPOSTA = "IID_EP_Risposta",
  IID_OL_CHECKLIST = "IID_OL_Checklist",
  IID_OL_SERVIZIO_AGGIUNTIVO = "IID_OL_ServizioAggiuntivo",
  IID_OL_APPARATO = "IID_OL_Apparato",
  IID_OL_APPUNTAMENTO = "IID_OL_Appuntamento",
  IID_OL_ACQUISITO_KO = "IID_OL_AcquisitoKo",
  IID_OL_ACCETTATO_KO = "IID_OL_AccettatoKo",
  IID_OL_ESPLETATO_KO = "IID_OL_EspletatoKo",
  IID_OL_ESPLETATO_OK = "IID_OL_EspletatoOk",
  IID_OL_ESPLETATO_OK_OF = "IID_OL_EspletatoOkOF",
  IID_OL_ANNULLATO = "IID_OL_Annullato",
  IID_OL_COMMUNICATION = "IID_OL_Communication",
  GLOBAL_BATCH_ACTIVITIES = "GLOBAL_BATCH_ACTIVITIES",
  PROJECT_BATCH_ACTIVITIES = "PROJECT_BATCH_ACTIVITIES",
  USER_BATCH_ACTIVITIES = "USER_BATCH_ACTIVITIES",
  IID_OL_SOSPENSIONE = "IID_OL_Sospensione",
  IID_EP_TICKET = "IID_EP_Ticket",
  IID_OL_SOLLECITO = "IID_OL_Sollecito",
  IID_OL_RISPOSTA_SOLLECITO = "IID_OL_RispostaSollecito",
  IID_OL_SUPPORTO = "IID_OL_Supporto",
  IID_OL_RISOLUZIONE = "IID_OL_Risoluzione",
  IID_OL_RISORSA = "IID_OL_Risorsa",
  IID_GENERIC_SUSPENSION = "IID_Generic_Suspension",
  META_INTERFACES_DATA = "Meta_Interfaces_Data",
  IID_EP_GISFO_SUPPORT = "IID_EP_GisfoSupport",
  IID_GR_RESOURCES = "IID_GR_Resources",
  IID_GR_TASKS = "IID_GR_Tasks",
  IID_GISFO_WORKORDER = "IID_Gisfo_Workorder",
  IID_OLO_DEACTIVATION = "IID_OLO_Deactivation",
  IID_OLO_DEACTIVATION_VALIDATION = "IID_OLO_Deactivation_Validation",
  IID_OLO_DEACTIVATION_PHYSIC = "IID_OLO_Deactivation_Physic",
  IID_GENERIC_KO = "IID_Generic_Ko",
  IID_MAIL_GTW_SOURCE = "IID_Mail_Gtw_Source",
  IID_ASSURANCE_TICKET = "IID_Assurance_Ticket",
  IID_GENERIC_OK = "IID_Generic_Ok",
  RESOURCES = "Resources",
  SHARED_RESOURCES = "Shared_Resources",
  RESOURCE_ITEMS = "Resource_Items",
  KEYVALUES = "Keyvalues",
  IID_NETWORK_ITEMS = "IID_Network_Items",
  IID_FAULT_MANAGEMENT = "IID_Fault_Management",
  IID_GENERIC_APPOINTMENT = "IID_Generic_Appointment",
  IID_OL_OLO_REQUEST_OF = "IID_OL_OloRequest_OF",
  IID_OL_RISORSA_PNI = "IID_OL_Risorsa_PNI",
  IID_ISSUE_LINK = "IID_IssueLink",
  IID_ISSUE_LINKED = "IID_IssueLinked",
  IID_SLAEDITOR = 'IID_SLAEditor',
  IID_RISORSA_LORA = 'IID_OL_Risorsa_Lora',
  IID_CHECKLIST_GISFO = 'IID_Checklist_Gisfo',
  IID_ESPLETATO_OK_CHECKLIST_GISFO = "IID_Espletato_OK_Checklist_Gisfo",
  IID_PORTALE_CONTRATTI = 'IID_Portale_Contratti',
  IID_CONFERMA_APPUNTAMENTO = 'IID_Conferma_Appuntamento',
  IID_RISORSE_CREATION = 'IID_Risorse_Creation',
  IID_RISORSE_VERIFICA = 'IID_Risorse_Verifica',
  IID_RISORSE_PERMESSO_PUBBLICO = 'IID_Risorse_Permesso_Pubblico',
  IID_RISORSE_IRU_ACQUISIZIONE = 'IID_Risorse_Iru_Acquisizione',
  TYPE_CATEGORY = 'TypeCategory',
  IID_OLO_POP_SVLAN = 'IID_olo_pop_svlan',
  ANAGRAFICA_SERVIZIO_AGGIUNTIVO = 'Anagrafica_Servizio_Aggiuntivo',
  ANAGRAFICA_APPARATO = 'Anagrafica_Apparato',
  OLO_ANAGRAFICA_SERVIZIO_AGG = 'Olo_Anagrafica_Servizio_Agg',
  OLO_ANAGRAFICA_APPARATO = 'Olo_Anagrafica_Servizio_Apparato',
  ARTICOLO_PORTALE_OLO_FE = 'Articolo_Portale_Olo_Fe',
  IID_APPARATO_SPLITTER = 'IID_Apparato_Splitter',
  IID_PRATICA_IRU_CUSTOMER = 'IID_Pratica_Iru_Customer',
  IID_PRATICA_IRU_PROVIDER = 'IID_Pratica_Iru_Provider',
  IID_UNLOCK_CODE = 'IID_Unlock_Code',
  ANAGRAFICA_CUSTOMER = 'Anagrafica_Customer',
  IID_FEASABILITY_CONNECTION_REQUEST = 'IID_Feasability_Connection_Request',
  IID_FEASABILITY_REQUEST_IDENTIFIER = 'IID_Feasability_Request_Identifier',
  IID_FEASABILITY_RESPONSE = 'IID_Feasability_Response',
  IID_FEASABILITY_ASSOCIATION = 'IID_Feasability_Association',
}
// TODO: IID_OL_VLAN = "IID_OL_Vlan", dopo risorsa_pni, è ciò che manca alla enum Topics

export enum IssueTopics {
  IID_OL_CLIENTE = "IID_OL_Cliente",
  IID_OL_CONTRATTO = "IID_OL_Contratto",
  IID_OL_RIFERIMENTI = "IID_OL_Riferimenti",
  IID_OL_RIFERIMENTI_UI = "IID_OL_RiferimentiUi",
  IID_OL_CONDOMINIO = "IID_OL_Condominio",
  IID_OL_CHECKLIST = "IID_OL_Checklist",
  IID_OL_OLO_REQUEST = "IID_OL_OloRequest",
  IID_OL_ACTIVATION_REQUEST = "IID_OL_ActivationRequest",
  IID_EP_ASSETS = "IID_EP_Assets",
  IID_OL_ACQUISITO_KO = "IID_OL_AcquisitoKo",
  IID_OL_ACCETTATO_KO = "IID_OL_AccettatoKo",
  IID_OL_ESPLETATO_OK = "IID_OL_EspletatoOk",
  IID_OL_ESPLETATO_OK_OF = "IID_OL_EspletatoOkOF",
  IID_OL_ESPLETATO_KO = "IID_OL_EspletatoKo",
  IID_OL_ANNULLATO = "IID_OL_Annullato",
  IID_EP_RICHIESTA_PERMESSO = "IID_EP_Richiesta_Permesso",
  IID_EP_RISPOSTA = "IID_EP_Risposta",
  IID_OL_SERVIZIO_AGGIUNTIVO = "IID_OL_ServizioAggiuntivo",
  IID_OL_APPARATO = "IID_OL_Apparato",
  IID_OL_APPUNTAMENTO = "IID_OL_Appuntamento",
  IID_OL_COMMUNICATION = "IID_OL_Communication",
  IID_OL_SOSPENSIONE = "IID_OL_Sospensione",
  ISSUES = 'Issues',
  ATTACHMENT = 'Attachment',
  ISSUE_COMMENTS = 'IssueComments',
  IID_OL_SOLLECITO = "IID_OL_Sollecito",
  IID_OL_RISPOSTA_SOLLECITO = "IID_OL_RispostaSollecito",
  IID_OL_SUPPORTO = "IID_OL_Supporto",
  IID_OL_RISOLUZIONE = "IID_OL_Risoluzione",
  IID_OL_RISORSA = "IID_OL_Risorsa",
  IID_GENERIC_SUSPENSION = "IID_Generic_Suspension",
  IID_EP_GISFO_SUPPORT = "IID_EP_GisfoSupport",
  IID_GR_RESOURCES = "IID_GR_Resources",
  IID_GR_TASKS = "IID_GR_Tasks",
  IID_GISFO_WORKORDER = "IID_Gisfo_Workorder",
  IID_OLO_DEACTIVATION = "IID_OLO_Deactivation",
  IID_OLO_DEACTIVATION_VALIDATION = "IID_OLO_Deactivation_Validation",
  IID_OLO_DEACTIVATION_PHYSIC = "IID_OLO_Deactivation_Physic",
  IID_GENERIC_KO = "IID_Generic_Ko",
  IID_MAIL_GTW_SOURCE = "mail_gtw_source",
  IID_ASSURANCE_TICKET = "IID_Assurance_Ticket",
  IID_APPARATO_SPLITTER = 'IID_Apparato_Splitter',
  IID_GENERIC_OK = "IID_Generic_Ok",
  IID_NETWORK_ITEMS = "IID_Network_Items",
  IID_FAULT_MANAGEMENT = "IID_Fault_Management",
  IID_OL_OLO_REQUEST_OF = "IID_OL_OloRequest_OF",
  IID_OL_RISORSA_PNI = "IID_OL_Risorsa_PNI",
  IID_OL_VLAN = "IID_OL_Vlan",
  IID_ISSUE_LINK = "IID_Issue_Link",
  IID_ISSUE_LINKED = "IID_Issue_Linked",
  IID_SLAEDITOR = 'IID_SLAEditor',
  IID_RISORSA_LORA = 'IID_Risorsa_Lora',
  IID_CHECKLIST_GISFO = 'IID_Checklist_Gisfo',
  IID_ESPLETATO_OK_CHECKLIST_GISFO = "IID_Espletato_OK_Checklist_Gisfo",
  IID_PORTALE_CONTRATTI = 'IID_Portale_Contratti',
  IID_CONFERMA_APPUNTAMENTO = 'IID_Conferma_Appuntamento',
  TYPE_CATEGORY = 'ITypeCategory',
  ANAGRAFICA_SERVIZIO_AGGIUNTIVO = 'Anagrafica_Servizio_Aggiuntivo',
  ANAGRAFICA_APPARATO = 'Anagrafica_Apparato',
  ARTICOLO_PORTALE_OLO_FE = 'Articolo_Portale_Olo_Fe',
  IID_PRATICA_IRU_CUSTOMER = 'IID_Pratica_Iru_Customer',
  IID_PRATICA_IRU_PROVIDER = 'IID_Pratica_Iru_Provider',
  IID_UNLOCK_CODE = 'IID_Unlock_Code',
  ANAGRAFICA_CUSTOMER = 'Anagrafica_Customer'
}

/*
  TODO: cosa manca a issueTopics
  IID_EP_TICKET = "IID_EP_Ticket",
  IID_GENERIC_APPOINTMENT = "IID_Generic_Appointment",
  IID_OLO_POP_SVLAN = 'IID_olo_pop_svlan',
  OLO_ANAGRAFICA_SERVIZIO_AGG = 'Olo_Anagrafica_Servizio_Agg',
  OLO_ANAGRAFICA_APPARATO = 'Olo_Anagrafica_Servizio_Apparato',
  (
    Queste invece non mancano, ma sono diverse nel valore:
    IID_ISSUE_LINK = "IID_IssueLink",  (prima tra "Issue" e "Link" ci stava "_")
    IID_ISSUE_LINKED = "IID_IssueLinked", (prima tra "Issue" e "Linked" ci stava "_")
  )
*/

export type FilterType = {
  projectId?: string,
  updatedAt?: string,
  limited?: boolean,
  userId?: string,
  lastId?: string,
  companyId?: string,
  entity?: string,
}
